import { TemplateConfig } from '../types';

export const loveProspectConfig: TemplateConfig = {
  id: 'love-prospect',
  name: '恋爱前景',
  description: '分析恋爱前景和发展情况',
  cardCount: 4,
  
  fieldDefaults: {
    title: '恋爱前景',
    customerQuestion: '**我的恋爱前景分析**',
    cardPlaceholders: [
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 3 张牌',
      '请输入第 1 行第 1 张牌'
    ],
    cardInfos: [
      '自身情况，代表问卜当事人本身的状况，也包括内心的情绪',
      '对方情况，代表恋爱对方的情况，也包括对方的内心想法',
      '现状，表示目前问卜者与恋爱对象的恋爱关系状况',
      '未来，表示与对方关系未来的发展情况'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#eb2f96',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};